var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SvgFilters'),_c('HeroSection',{attrs:{"id":"home"}}),_c('ResumeSection'),_c('ProjectsSection'),_c('AppFooter',{attrs:{"id":"contact"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }